import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root',
})
export class WorklistService {
  constructor(private http: HttpClient) {}
  getExportReportData(url, dataForPost) {
    return this.http.post(url, dataForPost).pipe(
      map((response: any) => response?.data),
      catchError((error) => throwError(error))
    );
  }

  shareCase(postData): Observable<any> {
    return this.http.post('/workflow/share-case', postData);
  }
}
